import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  private printableDataSubject = new BehaviorSubject<string>(''); // Initial value is an empty string
  printableData$ = this.printableDataSubject.asObservable();
  public orderStatusPacked = new Subject<boolean>();
  public orderDeliveredSubject = new Subject<any>();
  public orderDelayedSubject = new Subject<any>();

  // Method to update the data
  setPrintableData(name: string) {
    this.printableDataSubject.next(name);
  }


  getStatusValue(item: any) {
    let statusVal: any = {};
    if (item) {
      statusVal = 'Active';
    } else {
      statusVal = 'InActive';
    }
    return statusVal;
  }

  getStatusRetrunValue(item: any) {
    let statusVal: any = {};
    if (item == 'Active') {
      statusVal = true;
    } else {
      statusVal = false;
    }
    return statusVal;
  }


  staffOrderPrint(orderDetails) {

    const productHTML = orderDetails.products.map(product => {
      return `<tr>
                <td colspan="2" style="padding-top:5px">${product.name}</td>
                <td colspan="2">${product.barcode}</td>
              </tr>
              <tr style=" border-bottom: 1px dashed #ccc; ">
                <td style="padding-left:10px;padding-bottom: 5px; ">${product.unit}</td>
                <td style="width:30px;">${product.quantity}</td>
                <td>${product.mrp}</td>
                <td>${product.sellingPrice ?? ''}</td>
                </tr>`
    });
    const popupWin = window.open('', '_blank', 'width=800,height=600');
    popupWin?.document.open();
    popupWin?.document.write(`
     <html>
        <head>
         <style>
            @page {
              margin: 0;
            }

            body {
              font-family: Arial, sans-serif;
                font-family: "Courier Prime", monospace;
              margin: 0;
              padding: 0;
            }

            .receipt {
              font-size: 14px;
            }

            .receipt h2 {
              text-align: center;
            }

            .receipt .item {
              display: flex;
              justify-content: space-between;
            }

            .receipt .total {
              text-align: right;
            }

            .company-info {
              text-align: center;
              border-bottom: 1px dashed #000;
            }

            .company-info img {
              width: 75px;
            }

            .company-name {
              font-weight: bold;
              font-size: 12px;
              margin: 5px;
            }

            .app-details {
              text-align: center;
            }

            .bill-info {
              display: flex;
              justify-content: space-between;
              padding: 5px;
              border-bottom: 1px dashed #000;
            }

            .product-info {
              text-align: left;
              padding: 5px;
            }

            table {
              width: 100%;
              border-bottom: 1px dashed #000;
              font-size: 14px;
              border-collapse: collapse;
            }

            table td {
              padding: 0 5px;
            }

            table td,
            table th {
              text-align: left;
            }

            tfoot {
              border-top: 1px dashed #000;
            }

            .shop-details {
              font-size: 12px;
              text-align: center;
              border-bottom: 1px dashed #000;
              padding: 5px;
            }

            .store-info {
              font-size: 12px;
              text-align: center;
              padding: 5px;
              border-bottom: 1px dashed #000;
            }

            .store-name {
              font-size: 10px;
              font-weight: bold;
            }

            .bill-details {
              text-align: center;
              padding: 5px;
              border-bottom: 1px dashed #000;
            }

            .app-details img {
              width: 100px
            }
          </style>
        </head>

        <body onload="window.print();window.close()">

          <div style="text-align: center;margin-top:3px;">Staff Order Print </div>
          <div class="bill-info">
            <div class="bill-no">Order No: ${orderDetails.orderNo}</div>
            <div class="bill-date">Bill Dt: ${this.formatDate(orderDetails.orderDate)}</div>
          </div>
          <div class="product-info">
            <table>
              <tr>
                <th colspan="2">Product Name</th>
                <th colspan="2"> BarCode </th>
              </tr>
              <tr>
                <th>Unit</th>
                <th style="width:30px;">Qty</th>
                <th>Price</th>
                <th>Amount</th>
              </tr>
              ${productHTML.join('')}
            </table>
          </div>
        </body>
      </html>
      `);
    popupWin?.document.close();
  }


  retailCounterPrintOrder(orderDetails, showQRcode = false) {
    const companyInfo = {
      comapnyImage: 'assets/images/project-images/logo.png',
      qrImage: 'assets/images/logo/qrcode-app.jpg',
      name: 'Rakee Kisan Market Private Limited.',
      // cin: 'U01100AP2016PTC103398',
      gstin: '37AAICP6288N1ZH',
      fssai: '10124022000236',
      address: 'Building No./Flat No.: 10-5-80/B, VADDERA BAZAR, NARASARAOPET,Guntur, Andhra Pradesh, 522601',
    };

    const scanTxt = `
    <div class="scan-text">
            <img
              src="${companyInfo.qrImage}"
              alt="QR code">
            <div class="text" style="font-size:12px;">Scan to download our App</div>
          </div>
    `

    // Group products by taxRate
    const groupedProducts = {};
    orderDetails.products.forEach(p => {
      let taxObj = '' + p.taxRate + (p.cessRate ? p.cessRate : '');
      if (!groupedProducts[taxObj]) groupedProducts[taxObj] = [];
      groupedProducts[taxObj].push(p);
    });

    // Build Product Table
    let productHTML = "";
    let grandTotal = 0, totalQty = 0, totalItems = 0;

    Object.keys(groupedProducts).sort((a, b) => Number(a) - Number(b)).forEach((taxRate, index) => {
      const group = groupedProducts[taxRate];
      const groupHasCess = group.some(p => p.cess);

      productHTML += `
      <tr>
        <td style="text-align:right;font-weight:bold; border-top:1px dotted #000;">${index + 1})</td>
        <td colspan="4" style="font-weight:bold; border-top:1px dotted #000;">
          CGST @ ${Number(group[0].taxRate)/2}%, SGST @ ${Number(group[0].taxRate)/2}% ${groupHasCess ? `, CESS @ ${group.find(p => p.cess)?.cess}%` : ""}
        </td>
      </tr>
    `;

      group.forEach(p => {
        grandTotal += p.sellingPrice;
        totalQty += Math.ceil(p.quantity);
        totalItems++;
        const productIcon = p.isKitchenProduct ? '<i class="fa fa-cutlery" aria-hidden="true"></i>' : '<i class="fa fa-shopping-basket" aria-hidden="true"></i>'
        productHTML += `
        <tr>
          <td>${p.hsn}</td>
          <td>${showQRcode ? '' : productIcon} ${p.name}</td>
          <td style="text-align:center;">${p.quantity}</td>
          <td style="text-align:right;">${p.mrp.toFixed(2)}</td>
          <td style="text-align:right;">${p.sellingPrice.toFixed(2)}</td>
        </tr>
      `;
      });
    });

    let gstHTML = "";
    orderDetails.annexure.forEach(data => {
         gstHTML += `
      <tr>
        <td style="font-size:8px;">${data.taxRate.toFixed(2)}</td>
        <td style="font-size:8px;">${data.cessRate.toFixed(2)}</td>
        <td style="text-align:right;font-size:8px;">${data.taxableValue.toFixed(2)}</td>
        <td style="text-align:right;font-size:8px;">${data.cgst.toFixed(2)}</td>
        <td style="text-align:right;font-size:8px;">${data.sgst.toFixed(2)}</td>
        <td style="text-align:right;font-size:8px;">${data.cess.toFixed(2)}</td>
        <td style="text-align:right;font-size:8px;">${(data.taxAmount).toFixed(2)}</td>
      </tr>`;
    });
    const cashPaid = Number(orderDetails?.billDetails?.cashPaid || 0);
    const changeToReturn = Number(orderDetails?.billDetails?.changeToReturn || 0);
    const pendingAmount = Number(orderDetails?.billDetails?.pendingAmount || 0);
    const cashSettlementHtml = cashPaid > 0
      ? `
      <hr>
      <table style="font-size:12px;">
        <tr>
          <td style="text-align:left;">Cash Received</td>
          <td style="text-align:right;">Rs. ${cashPaid.toFixed(2)}</td>
        </tr>
        <tr>
          <td style="text-align:left;">Balance to Return</td>
          <td style="text-align:right;">Rs. ${changeToReturn.toFixed(2)}</td>
        </tr>
        ${pendingAmount > 0 ? `
        <tr>
          <td style="text-align:left;">Pending Amount</td>
          <td style="text-align:right;">Rs. ${pendingAmount.toFixed(2)}</td>
        </tr>` : ``}
      </table>
      `
      : ``;

    const popupWin = window.open('', '_blank', 'width=800,height=600');
    popupWin?.document.open();
    popupWin?.document.write(`
  <html>
  <head>
    <style>
      @page { margin: 0; }
      body { font-family: "Courier Prime", monospace; margin: 0; padding: 0; }
      table { width: 100%; border-collapse: collapse; font-size: 9px; }
      th, td { padding: 2px; }
      hr { border-top: 1px dashed #000; margin: 4px 0; }
      .total-row { border-top: 1px dashed #000; font-weight: bold; }
      .app-details { text-align: center; }
      .app-details img { width: 100px;}
      .invoice{ text-align: center; margin-top: 3px; font-size: 14px; }
      .bill-info {  border-bottom: 1px dashed #000;font-size: 11px; }
    </style>
     <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  </head>
  <body onload="window.print();window.close()">
    <div style="text-align:center;font-size:11px;">
      <img src="${companyInfo.comapnyImage}" width="60" /><br>
      <strong>${companyInfo.name}</strong><br>
      Address : ${companyInfo.address}<br>
      GSTIN: ${companyInfo.gstin}<br>
      FSSAI No: ${companyInfo.fssai}
    </div>

    <hr>
     <div class="invoice">INVOICE</div>
        <div class="bill-info">
          <div class="bill-no">Order No: ${orderDetails.orderNo}</div>
          <div class="bill-date">Bill Dt: ${this.formatDate(orderDetails.orderDate)}</div>
        </div>
      <table>
        <thead>
          <tr>
            <th style="text-align:left;">HSN</th>
            <th style="text-align:left;">Particulars</th>
            <th style="text-align:center;">Qty</th>
            <th style="text-align:right;">Rate</th>
            <th style="text-align:right;">Value</th>
          </tr>
        </thead>
        <tbody>${productHTML}</tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="2">Items: ${totalItems}</td>
            <td style="text-align:center;">${totalQty}</td>
            <td colspan="2" style="text-align:right;">₹ ${grandTotal.toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
      
      <hr style="border-top:2px solid #000; margin:4px 0;">
      <table style="font-size:14px; font-weight:bold;">
        <tr>
          <td style="text-align:left;">Grand Total</td>
          <td style="text-align:right;">₹ ${grandTotal.toFixed(2)}</td>
        </tr>
      </table>

      ${cashSettlementHtml}
      <hr>
      <p style="margin: 5px 0; font-size: 12px; text-align:center;">* GST Breakup as per Annexure</p>

      <table>
        <thead>
          <tr>
            <th style="text-align:left;font-size:8px;">Tax Rate %</th>
            <th style="text-align:left;font-size:8px;">Cess Rate %</th>
            <th style="text-align:right;font-size:8px;">Taxable Value</th>
            <th style="text-align:right;font-size:8px;">CGST Amt.</th>
            <th style="text-align:right;font-size:8px;">SGST Amt.</th>
            <th style="text-align:right;font-size:8px;">Cess Amt.</th>
            <th style="text-align:right;font-size:8px;">Total Tax Amt.</th>
          </tr>
        </thead>
        <tbody>${gstHTML}</tbody>
      </table>
      
    
      <div class="app-details">
          ${showQRcode ? scanTxt : ``}
          <div style="padding: 25px;font-size:11px;"> Thanks for shoping with us ❤︎</div>
      </div>
  </body>
  </html>
  `);
    popupWin?.document.close();
  }

  printOrderData(orderData, showQRcode = false) {
    const companyInfo = {
      comapnyImage: 'assets/images/project-images/logo.png',
      qrImage: 'assets/images/logo/qrcode-app.jpg',
      name: 'Rakee Kisan Market Private Limited.',
      gstin: '37AAICP6288N1ZH',
      fssai: '10124022000236',
    }

    const retailerInfo = {
      name: 'Rakee Mart',
      address: 'Building No./Flat No.: 10-5-80/B, VADDERA BAZAR, NARASARAOPET,Guntur, Andhra Pradesh, 522601',
    }

    const scanTxt = `
      <div class="scan-text">
              <img
                src="${companyInfo.qrImage}"
                alt="QR code">
              <div class="text">Scan to download our App</div>
            </div>
      `

    const orderDetails = orderData;
    const productHTML = orderDetails.products.map(product => {
      const productIcon = product.isKitchenProduct ? '<i class="fa fa-cutlery" aria-hidden="true"></i>' : '<i class="fa fa-shopping-basket" aria-hidden="true"></i>'
      return `<tr>
                  <td colspan="2" style="padding-top:5px"> ${productIcon} ${product.name}</td>
                  <td style="padding-bottom: 5px; ">${product.unit}</td>
                  <td style="width:30px;text-align:right;">${product.quantity}</td>
                </tr>
                <tr style=" border-bottom: 1px dashed #ccc; ">
                  <td colspan="2">  ${product.hsn}</td>
                  <td>${product.sellingPricePerUnit ? product.sellingPricePerUnit : ''}</td>
                  <td  style="text-align:right">${product.sellingPrice ? product.sellingPrice.toFixed(2) : ''}</td>
                  </tr>`
    });
    const popupWin = window.open('', '_blank', 'width=800,height=600');
    popupWin?.document.open();
    popupWin?.document.write(`
           <html>
      <head>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
         <link href="https://fonts.googleapis.com/css2?family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet">
        <style>
          @page {
            margin: 0;
          }

          body {
            font-family: "Courier Prime", monospace;
            margin: 0;
            padding: 0;
          }

          .receipt {
            font-size: 10px;
          }

          .receipt h2 {
            text-align: center;
          }

          .receipt .item {
            display: flex;
            justify-content: space-between;
          }
            .invoice{
              text-align: center;
              margin-top: 3px;
              font-size: 14px;
            }

          .receipt .total {
            text-align: right;
          }

          .company-info {
            text-align: center;
            border-bottom: 1px dashed #000;
          }

          .company-info img {
            width: 75px;
          }

          .company-name {
            font-weight: bold;
            font-size: 12px;
            margin: 5px;
          }

          .app-details {
            text-align: center;
          }

          .bill-info {
            display: flex;
            justify-content: space-between;
            padding: 5px;
            border-bottom: 1px dashed #000;
          }

          .product-info {
            text-align: left;
            padding: 5px;
          }

          table {
            width: 100%;
            border-bottom: 1px dashed #000;
            font-size: 10px;
            border-collapse: collapse; 
          }

          table td {
            padding: 0 5px;
          }

          table td,
          table th {
            text-align: left;
          }

          tfoot {
            border-top: 1px dashed #000;
          }

          .shop-details {

            font-size: 12px;
            text-align: center;
            border-bottom: 1px dashed #000;
            padding: 5px;
          }

          .store-info {
            font-size: 10px;
            text-align: center;
            padding: 5px;
            border-bottom: 1px dashed #000;
          }

          .store-name {
            font-size: 10px;
            font-weight: bold;
          }

          .bill-details {
            text-align: right;
            padding: 5px;
            border-bottom: 1px dashed #000;
            margin-right: 5px;
          }

          .app-details img {
            width: 100px
          }
          .d-flex{
            display: flex;
          } 
          .justify-content-between{
            justify-content: space-between;
          }
        </style>
      </head>

      <body onload="window.print();window.close()">
        <div id="printable-bill" class="receipt">
          <div class="company-info">
            <img src="${companyInfo.comapnyImage}" alt="rakee-logo" />
            <div class="company-name">Rakee Kisan Market Private Limited.</div>
             <div class="store-info">
              <div class="store-address">${retailerInfo.address}</div>
            </div>
          </div>
          <div class="">
            <div class="shop-details">
              <div class="shop-text">GSTIN:-${companyInfo.gstin}</div>
              <div class="shop-text">FSSAI No:-${companyInfo.fssai}</div>
            </div>
           
          </div>

          <div class="invoice">INVOICE</div>
          <div class="bill-info">
            <div class="bill-no">Order No: ${orderDetails.orderNo}</div>
            <div class="bill-date">Bill Dt: ${this.formatDate(orderDetails.orderDate)}</div>
          </div>
          <div class="product-info">
            <table>
              <tr>
                <td colspan="2">Product Name</td>
                <td style="padding-bottom: 5px;">Unit</td>
                  <td style="width:30px;padding-bottom: 5px;text-align:right;">Qty</td>     
              </tr>
              <tr>
                <td colspan="2"> HSN </td>
                  <td style="padding-bottom: 5px;">Price</td>
                  <td style="padding-bottom: 5px;text-align:right;">Amount </td>
              </tr>
             ${productHTML.join('')}
              <tfoot>
              <td colspan="3"></td>
                <td style="text-align: right; padding: 5px 0;">Items(<strong>${orderDetails.products.length}</strong>)</td>
              </tfoot>
            </table>          
          </div>
          <div class="bill-details">
          <div class="bill-amount d-flex justify-content-between">
              <span>Items Amount  </span><span> ${Number(orderDetails.billDetails.itemsNetAmount).toFixed(2)}</span>
            </div>
              <div class="bill-amount d-flex justify-content-between">
              <span>Additional Charges </span> <span>${Number(orderDetails.billDetails.charges).toFixed(2)}</span>
            </div>
               <div class="bill-amount d-flex justify-content-between">
              <span>Amount ${orderDetails.paymentType === 'COD' ? 'To Pay' : 'Paid'} </span> <span> ${Number(orderDetails.billDetails.total).toFixed(2)}</span>
            </div>
            <div class="bill-amount d-flex justify-content-between">
             <span>Amount Saved  </span><span> ${Number(orderDetails.billDetails.amountSaved).toFixed(2)}</span>
            </div>
          </div>

          <div class="app-details">
              ${showQRcode ? scanTxt : ``}
              <div style="padding: 25px;"> Thanks for shoping with us ❤︎</div>
          </div>
        </div>
      </body>
      </html>
          `);
    popupWin?.document.close();
  }

  convertToPrintObj(selectedOrder, considerAdditonalCharge = false, cashSettlement: any = null) {
    const toPay = Number(selectedOrder?.billDetails?.toPay || 0);
    const itemsNetAmountValue = Number(selectedOrder?.billDetails?.itemsNetAmount || 0);
    const chargesFromTotals = Number((toPay - itemsNetAmountValue).toFixed(2));
    const cashPaid = Number(cashSettlement?.cashPaid ?? selectedOrder?.billDetails?.cashPaid ?? 0);
    const changeToReturn = Number(cashSettlement?.changeToReturn ?? selectedOrder?.billDetails?.changeToReturn ?? 0);
    const pendingAmount = Number(cashSettlement?.pendingAmount ?? selectedOrder?.billDetails?.pendingAmount ?? 0);

    return {
      orderNo: selectedOrder.orderNumber,
      orderDate: selectedOrder.createdAt,
      paymentType: selectedOrder.paymentType,
      products: selectedOrder.products.map(x => {
        return {
          name: x.name,
          quantity: x.cartCount,
          mrp: x.mrpPrice,
          sellingPrice: x.sellingPrice,
          sellingPricePerUnit: (x.sellingPrice / x.cartCount).toFixed(2),
          unit: (x.unitValue ? (x.unitValue + x.unit) : ''),
          barcode: x.barcode,
          isKitchenProduct: x.type === 'kitchen',
          hsn: x.hsn ?? '',
          taxRate: x.taxRate ?? '', 
          cessRate: x.cessRate ?? '',
          cgst: x.cgst ?? '',
          sgst: x.sgst ?? '',
          igst: x.igst ?? '',
          cess: x.cess ?? '',
          taxAmount: x.taxAmount ?? '',
          taxableValue: x.taxableValue ?? '',
          total: x.total ?? ''
        }
      }),
      billDetails: {
        total: selectedOrder.billDetails.toPay,
        amountSaved: selectedOrder.billDetails.billSavedAmount,
        grandTotal: selectedOrder.billDetails.billGrossAmount,
        charges: considerAdditonalCharge
          ? chargesFromTotals
          : (selectedOrder.billDetails.billGrossAmount - selectedOrder.billDetails.itemsGrossAmount),
        itemsNetAmount
          : selectedOrder.billDetails.itemsNetAmount,
        cashPaid,
        changeToReturn,
        pendingAmount,
      },
      annexure : selectedOrder.annexure ?? []
    }

  }

  formatDate(isoString) {
    const date = new Date(isoString);

    // Format the date
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // Format the time
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

}
